export const dimensions = {
  oneInchRem: 7, // one inch is 7 rem, 5 inches is 35 rem
  rem2px: 8, // 8 px in a rem
  oneInchPx: 56, // 56 px in an inch
};
